export default class Status {
  public displayName: string = ''
  public intValue: number = 0

  constructor(displayName: string = '', intValue: number = 0) {
    this.displayName = displayName
    this.intValue = intValue
  }
}
